import React from "react";
import styles from "./containerOptions.module.css";
import Button from "common/Button";

const ContainerOptions = ({ Fields = [] }) => {
  return (
    <>
      {Fields?.map((e) => {
        if (e?.type == "button") {
          let customStyles = {
            background: "white",
            padding: "8px",
            fontFamily: "Medium",
            height: "4rem",
          };

          if (e?.position == "pre") {
            customStyles = {
              ...customStyles,
              paddingLeft: "37px",
              width: "123px",
            };
          } else {
            customStyles = {
              ...customStyles,
              paddingRight: "37px",
              width: "137px",
            };
          }

          if (e?.position == "pre") {
            return (
              <div className={styles.preWrapper}>
                <img
                  src="/icons/calendar.svg"
                  className={styles.preButtonIcon}
                />
                <Button
                  label={e?.label}
                  buttonOverrideInlineStyle={customStyles}
                  {...e}
                />
              </div>
            );
          } else {
            return (
              <div className={styles.preWrapper}>
                <img
                  src="/icons/calendar.svg"
                  className={styles.postButtonIcon}
                />
                <Button
                  label={e?.label}
                  buttonOverrideInlineStyle={customStyles}
                />
              </div>
            );
          }
        }

        if (e?.type == "search") {
          return (
            <div className={styles.searchWrapper}>
              <img src="/icons/search.svg" className={styles.searchIcon} />
              <input
                placeholder={e?.label}
                style={{ padding: "8px !important" }}
                className={styles.search}
                onChange={e?.handleOnChange}
              />
            </div>
          );
        }
      })}
    </>
  );
};

export default ContainerOptions;
